import { render, staticRenderFns } from "./NewBalance.vue?vue&type=template&id=7d235178&scoped=true&"
import script from "./NewBalance.vue?vue&type=script&lang=js&"
export * from "./NewBalance.vue?vue&type=script&lang=js&"
import style0 from "./NewBalance.vue?vue&type=style&index=0&id=7d235178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d235178",
  null
  
)

export default component.exports